import { Suspense, lazy } from 'react';
import { Box, Link, Text } from '@radix-ui/themes';

const FooterStatistic = lazy(() => import('./FooterStatistic'));

export default function FooterBlock({ isHome }) {
    return (
        <Box className="redesign-footer-stats">
            <Suspense>
                <FooterStatistic />
            </Suspense>
            <Box mt="2">
                <Text size="2" style={{ color: 'var(--rd-text-muted)' }}>
                    特别声明：包含政治、色情、赌博与暴力等违规内容的博客，一经发现，将被永久移出收录名单！
                    举报违规博客，请「<Link href="mailto:bokehub@qq.com?subject=违规内容举报">联系站长</Link>」！
                </Text>
            </Box>
        </Box>
    );
}
